import * as React from 'react'
import PropTypes from 'prop-types'
import { CustomPropTypes } from '../../../support'
import type { HeadingForwardRef } from '../../../types'

export const headingLevels = ['1', '2', '3', '4', '5', '6'] as const
export type HeadingLevel = (typeof headingLevels)[number]

export interface BaseHeadingTagProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  children?: React.ReactNode
  /**
   * A React ref to assign to the HTML node representing the Heading element.
   */
  forwardedRef?: HeadingForwardRef
  /**
   * The semantic HTML section heading level.
   */
  level: HeadingLevel
}

export function BaseHeadingTag({
  level,
  children,
  forwardedRef,
  ...restProps
}: BaseHeadingTagProps) {
  switch (level) {
    case '1':
      return (
        <h1 ref={forwardedRef} {...restProps}>
          {children}
        </h1>
      )
    case '2':
      return (
        <h2 ref={forwardedRef} {...restProps}>
          {children}
        </h2>
      )
    case '3':
      return (
        <h3 ref={forwardedRef} {...restProps}>
          {children}
        </h3>
      )
    case '4':
      return (
        <h4 ref={forwardedRef} {...restProps}>
          {children}
        </h4>
      )
    case '5':
      return (
        <h5 ref={forwardedRef} {...restProps}>
          {children}
        </h5>
      )
    default:
      return (
        <h6 ref={forwardedRef} {...restProps}>
          {children}
        </h6>
      )
  }
}

BaseHeadingTag.propTypes = {
  children: PropTypes.node,
  forwardedRef: CustomPropTypes.ReactRef,
  level: PropTypes.oneOf(headingLevels).isRequired,
}
